var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGcpVpc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aecbfa;}.cls-2{fill:#669df6;}.cls-3{fill:#4285f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_VirtualPrivateCloud_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16,
    y: 2,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19,
    y: 2,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 16,
    y: 16,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19,
    y: 16,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 2,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 2,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 16,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 5,
    y: 16,
    width: 3,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8,
    y: 4,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 8,
    y: 18,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 18,
    y: 8,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4,
    y: 8,
    width: 2,
    height: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 4,
    y: 8,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 18,
    y: 8,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8,
    y: 4,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 8,
    y: 18,
    width: 2,
    height: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpVpc);
export default __webpack_public_path__ + "static/media/gcp-vpc.a55febb5706934474d636dfeefd9b73d.svg";
export { ForwardRef as ReactComponent };